import { SetupWorkerTime } from '../../../../shared/types/setupWorkerTime.ts';
import { BarGraphData, BarGroup } from '../barGraphData.ts';
import { DEFAULT_COLOR } from '../reportGraphColors.ts';


// Show one column per worker, with total setup time in hours.
export function prepareSetupTotals(totals: SetupWorkerTime[]): BarGraphData {
    const barGroups: BarGroup[] = totals.map(({ worker, time, numSetups }) => {
        const hours = time / 3600_000;
        return {
            periodLabel: worker,
            bars: [{
                sections: [{
                    value: hours,
                    color: DEFAULT_COLOR,
                    labels: [
                        { position: 'above-top', text: `${hours.toFixed(1)}h` },
                        { position: 'below-top', text: numSetups + '' }
                    ],
                }],
            }],
        };
    });

    const maxValue = Math.max(1, ...totals.map(({ time }) => time / 3600_000)) * 1.1;
    return {
        barGroups,
        maxValue,
    };
}
